import React, { useState,useEffect } from "react";
import { Grid,Divider,CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IoMdPerson } from "react-icons/io";
import { toast } from "react-toastify";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { MdLock } from "react-icons/md";
import CustomInput from "../../Components/CustomInputs/CustomInputs";
import { GreenColorButton } from "../../Components/MaterialButtonStyle/StyleButton";
import Header from "../../Components/LandingPage/LandingPageHeader";
import { PostMethod } from "../../Helper/api"
import {encryptData } from "../../Helper/Encryptions"
const ApplicantLogin = () => {

  const navigate = useNavigate();
  const [userID, setUserID] = useState("");
  const [ipaddress, setipaddress] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [Password, setPassword] = useState({
    password: "",
    showPassword: false,
  });
  useEffect(()=>{
    GetIpaddress()
  },[])
  // const GetIpaddress =async()=>{
  //   try{
  //     const response =await  fetch("https://api64.ipify.org/?format=json")
  //     const data =await response.text()
  //     setipaddress(data)
  //   }catch(Error){
  //     console.log("Error GetIpaddress",Error)
  //   }
  // }
  const GetIpaddress = async () => {
    try {
      const response = await fetch("https://api64.ipify.org/?format=json")
      const data = await response.json()
      setipaddress(data.ip)
    } catch (Error) {
      console.log("Error GetIpaddress", Error)
      // Set a default IP if fetch fails
      setipaddress("0.0.0.0")
    }
  }
  const HandleClickShowPassword = () => {
    setPassword({ ...Password, showPassword: !Password.showPassword });
  };

  const HandleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const HandlePasswordChange = (event) => {
    setPassword({ ...Password, password: event.target.value });
  };

  const RegiterationSubmit = (e) => {
    e.preventDefault();
  };

  const ValidationEmails = (mail) => {
    /* eslint-disable */
    const regExp =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regExp.test(mail);
    /* eslint-enable */
  };

  const ValidatePassword = (password) => {
    var passwordValidation =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    return passwordValidation.test(password);
  };


  const LoginValidation = async() => {
    try {
      if (!userID) {
        toast.warn("Enter Valid Email");
        return;
      }
      if (!ValidationEmails(userID)) {
        toast.warn("Invalid Email Entered");
        return;
      }
      if (!Password.password) {
        toast.warn("Enter Password");
        return;
      }
      if (!ValidatePassword(Password.password)) {
        toast.warn(
          "Password Shall Be Minimum 8 Characters With One Uppercase, One Number And One Special Character"
        );
        return;
      }
      let url = "candidate/login";
      let method = "POST";
      let params = {
        email: encryptData(userID),
        password: encryptData(Password.password),
        ipaddress:ipaddress
      };
      setLoading(true)
      const response = await PostMethod({ url, method, params });
      if(response.status){
        setLoading(false)
        navigate("/verifyotp", { state: { isForgetPw: false, email: encryptData(userID),password : encryptData(Password.password) } })
      }else{
        setLoading(false)
        if(response.message){
          toast.error(response.message)
        }else{
          toast.error("Something went wrong please try again later")
        }
      }
    } catch (Error) {
      setLoading(false)
      toast.error("Something went wrong, try again later")
      console.log("Error in LoginValidation", Error);
    }
  };

  return (
    <Grid item container lg={12} className="loginbgbanner" >
      <Header />
      <Grid item container justifyContent={"space-between"} alignContent={"flex-start"} padding={4}>
        <Grid item container lg={5.8} md={5.8} sm={12} xs={12} className="bg-white borderRadius12 p-4" marginTop={window.innerWidth > 600 ? 0 : 4}>
          <h4 className="poppinsMedium Text-Prime-Black text-left">New Application</h4>
          <Divider className="mt-2 w-100" sx={{ border: "1px solid #0FBE7C" }} />
          <p className=" poppinsMedium Text-Prime-Black pt-3 text-left ">Welcome to the Police Force Recruitment Portal! By creating an account, you can:</p>
          <p className=" poppinsMedium Text-Prime-Black pt-3 pl-2 fontSize12 text-left">1. Begin your application process to become a member of the Police Force, allowing you to complete the required information at your convenience.</p>
          <p className=" poppinsMedium Text-Prime-Black pt-3 pl-2 fontSize12 text-left">2. If you need to pause your application, you can easily save your progress and return to it later. This feature ensures your efforts are preserved, allowing you to finish your application whenever it suits you.</p>
          <p className=" poppinsMedium Text-Prime-Black pt-3 pl-2 fontSize12 text-left">3. By setting up an account, you&apos;ll gain access to important notifications regarding upcoming events and activities related to the recruitment process. This keeps you informed about essential dates and opportunities, helping you stay engaged and prepared.</p>
          <p className=" poppinsMedium text-black pt-3 text-left">Creating your account is the first step toward a fulfilling career with the Police Force.</p>
          <Grid container justifyContent={"center"} className="pt-3">
            <GreenColorButton
              className="px-5 py-2"
              onClick={() => navigate("/newuserregistration")}
            >
              Register
            </GreenColorButton>
          </Grid>
        </Grid>
        <Grid item container lg={5.8} md={5.8} sm={12} xs={12} marginTop={window.innerWidth > 600 ? 0 : 4} alignContent={"flex-start"} justifyContent={"flex-start"} alignItems={"flex-start"} className="bg-white borderRadius12 p-4 ">
          <h4 className="poppinsMedium Text-Prime-Black text-left">Already Registered Applicants</h4>
          <Divider className="mt-2 w-100" sx={{ border: "1px solid #0FBE7C" }} />
          <Grid item lg={12} md={12} sm={12} xs={12} container flexDirection={"column"}>
            <form
              style={{ width: "100%", display: "contents" }}
              className="loginregister"
              onSubmit={RegiterationSubmit}
            >
              <Grid container>
                <p className=" poppinsMedium Text-Prime-Black pt-3 pb-2">
                  User Email
                </p>
                <CustomInput
                  placeholderColor={"#666666"}
                  placeholder="Enter your Email"
                  padding={"2.5% 3% 2.5% 3%"}
                  backgroundColor="#FFFFFF"
                  width={"100%"}
                  maxLength={100}
                  InputFrontProps={<IoMdPerson color="#222222" size={22} className="mr-2" />}
                  value={userID}
                  onChange={(e) => setUserID(e.target.value)}
                />
              </Grid>
              <Grid container>
                <p className=" poppinsMedium Text-Prime-Black pt-3 pb-2">Password</p>
                <CustomInput
                  placeholderColor={"#666666"}
                  placeholder="Enter Your Password"
                  type={Password.showPassword ? "text" : "password"}
                  padding={"2.5% 3% 2.5% 3%"}
                  backgroundColor="#FFFFFF"
                  width={"100%"}
                  maxLength={50}
                  InputFrontProps={<MdLock color="#222222" size={22} className="mr-2" />}
                  InputProps={Password.showPassword ? (
                    <IoEye
                      className="eyeIcons pointer"
                      onClick={() => HandleClickShowPassword("password")}
                      onMouseDown={HandleMouseDownPassword}
                      color="#222222" size={22}
                    />
                  ) : (
                    <IoEyeOff
                      className="eyeIcons pointer"
                      onClick={() => HandleClickShowPassword("password")}
                      onMouseDown={HandleMouseDownPassword}
                      color="#222222" size={22}
                    />
                  )}
                  onChange={(e) => HandlePasswordChange(e)}
                />
              </Grid>
              <Grid container justifyContent={"flex-end"} className="w-100">
                <p
                  className=" poppinsMedium Text-Prime-Black pt-3 pointer text-right"
                  role="presentation"
                  onClick={() => navigate("/forgotpassword",{state:{isApplicants:true}})}
                >
                  Forgot Password?
                </p>
              </Grid>
              <Grid container justifyContent={"center"} className="pt-3">
                <GreenColorButton
                  className="px-5 py-2"
                  disabled={isLoading}
                  onClick={() => LoginValidation()}
                >
                  
                  {isLoading ?   <CircularProgress size="1rem" style={{ color: "#fff" }} /> :"Login"}
                </GreenColorButton>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </Grid>

  );
};

export default ApplicantLogin;